import { waLink } from "@/lib/contact";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="hidden md:flex fixed bottom-6 right-6 z-40 items-center gap-2 bg-[#25D366] text-white px-5 py-3.5 rounded-full shadow-2xl hover:scale-[1.03] hover:shadow-3xl transition-all group"
      style={{ boxShadow: "0 10px 30px rgba(37, 211, 102, 0.4)" }}
    >
      <MessageCircle size={20} className="fill-white" strokeWidth={0} />
      <span className="font-medium text-sm hidden lg:inline">Chat on WhatsApp</span>
      <span className="absolute -top-1 -right-1 flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
      </span>
    </a>
  );
}
